// @flow
import { useState, useCallback } from "react";

const useToggle = (initialValue: boolean) => {
  const [value, setValue] = useState(initialValue);
  const toggleValue = useCallback(() => setValue(!value), [value, setValue]);

  return [value, toggleValue];
};

export default useToggle;
